// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1hMrY","content":"ManualTimeModal_content__1bDJu"};